var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60653 11.6067L2.12132 19.0919L0 16.9706L7.48521 9.48535L0.12118 2.12132L2.2425 0L9.60653 7.36403L16.9706 0L19.0919 2.12132L11.7279 9.48535L19.2131 16.9706L17.0917 19.0919L9.60653 11.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60653 11.6067L2.12132 19.0919L0 16.9706L7.48521 9.48535L0.12118 2.12132L2.2425 0L9.60653 7.36403L16.9706 0L19.0919 2.12132L11.7279 9.48535L19.2131 16.9706L17.0917 19.0919L9.60653 11.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60653 11.6067L2.12132 19.0919L0 16.9706L7.48521 9.48535L0.12118 2.12132L2.2425 0L9.60653 7.36403L16.9706 0L19.0919 2.12132L11.7279 9.48535L19.2131 16.9706L17.0917 19.0919L9.60653 11.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60653 11.6067L2.12132 19.0919L0 16.9706L7.48521 9.48535L0.12118 2.12132L2.2425 0L9.60653 7.36403L16.9706 0L19.0919 2.12132L11.7279 9.48535L19.2131 16.9706L17.0917 19.0919L9.60653 11.6067Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.2d0e08017b68561ca692299a81e0c2e5.svg";
export { ForwardRef as ReactComponent };